import { PaginatedColumn } from "../types/app";
import { JobTypeCategory, JobTypeRequest, JobTypeRequestTouched, Skill, SkillRequestTouched } from "../types/jobs";

export const JOB_SKILLS_TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: "Nombre",
    key: "name",
  },
  {
    label: "Activo",
    key: "active",
    centered: true,
    minWidth: 100,
    maxWidth: 100,
  },
  {
    label: "Actions",
    key: "actions",
    centered: true,
    minWidth: 100,
    maxWidth: 100,
  },
];

export const JOB_SKILL_DEFAULTS: Skill = {
  name: "",
  slug: "",
};

export const JOB_SKILL_TOUCHED_DEFAULTS: SkillRequestTouched = {
  nameTouched: false,
  slugTouched: false,
};

export const JOB_TYPES_TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: "Nombre",
    key: "name",
  },
  {
    label: "Costo",
    key: "cost",
  },
  {
    label: "Descripción",
    key: "description",
    flex: 1,
  },
  {
    label: "Activo",
    key: "active",
    centered: true,
    minWidth: 100,
    maxWidth: 100,
  },
  {
    label: "Actions",
    key: "actions",
    centered: true,
    minWidth: 100,
    maxWidth: 100,
  },
];

export const JOB_TYPE_DEFAULTS: JobTypeRequest = {
  name: "",
  tenants: [],
  technicianSkills: [],
  category: JobTypeCategory.installation,
};

export const JOB_TYPE_TOUCHED_DEFAULTS: JobTypeRequestTouched = {
  nameTouched: false,
  avgDurationTouched: false,
  costTouched: false,
  tenantsTouched: false,
  categoryTouched: false,
};
